export const THRESHOLD_KEY = "prime-manage-activities-compliance-threshold"